// src/components/Control/objectIcons.ts
// Значки предметов карты (robot/<id>/vision/objects) по меткам COCO
const ICONS: Record<string, string> = {
  chair: '🪑', couch: '🛋️', bed: '🛏️', 'dining table': '🍽️', tv: '📺', laptop: '💻',
  refrigerator: '🧊', toilet: '🚽', sink: '🚰', 'potted plant': '🪴', oven: '♨️', microwave: '📟',
  toaster: '🍞', clock: '🕰️', vase: '🏺', book: '📚', suitcase: '🧳', backpack: '🎒', bench: '🪑',
  bottle: '🍾', cup: '☕', bowl: '🥣', 'wine glass': '🍷', keyboard: '⌨️', mouse: '🖱️', remote: '🎛️',
  'cell phone': '📱', 'teddy bear': '🧸', umbrella: '☂️', handbag: '👜', bicycle: '🚲', cat: '🐈',
  dog: '🐕', bird: '🐦', 'sports ball': '⚽', scissors: '✂️', 'hair drier': '💨', toothbrush: '🪥',
};

export function objectIcon(label: string): string {
  return ICONS[label] ?? '📦';
}

// robot/<id>/vision/objects
export interface MapObject {
  id: number;
  label: string;
  label_ru: string;
  x: number;
  y: number;
  hits: number;
  first_seen: number;
  last_seen: number;
  part: string | null;
}

export interface MapObjectsMsg {
  timestamp: number;
  objects: MapObject[];
  bounds: [number, number, number, number] | null;
}
